import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseProductQuantityHistoryReasonType } from '../enums/warehouse-product-quantity-history-reason-type';
import { WarehouseProductQuantityHistoryReasonTypeProviderService } from '../providers/warehouse-product-quantity-history-reason-type-provider.service';

@Pipe({
  name: 'warehouseProductQuantityHistoryReasonType',
})
export class WarehouseProductQuantityHistoryReasonTypePipe implements PipeTransform {
  /* prettier-ignore */
  private readonly provider = inject(WarehouseProductQuantityHistoryReasonTypeProviderService);

  public transform(
    type: WarehouseProductQuantityHistoryReasonType,
  ): Observable<string> {
    return this.provider.label(type);
  }
}
